<template>
  <div class="site">
    <div :class="['uploader__bg', shouldShowBg]">
      <div class="bg"></div>
      <div class="text">Drop to start adding</div>
    </div>
    <BlockExpanded></BlockExpanded>
    <!-- Page View -->
    <div :class="['site-content', canEdit]">
      <router-view v-slot="{ Component, route }">
        <transition :enter-active-class="route.meta.enterClass" :leave-active-class="route.meta.leaveClass" name="fade" mode="out-in">
          <component :is="Component" />
        </transition>
      </router-view>
    </div>

  </div>
</template>

<script>
/* eslint-disable no-unused-vars */
/* eslint-disable no-empty */

import BlockExpanded from '@trust/components/BlockExpanded.vue'

export default {
  name: 'App',
  components: {
    BlockExpanded
  },
  data() {
      return {
      }
  },
  created() {
    if(window.location.href.includes('http://') && !window.location.href.includes('local:9001')) {
      window.location.replace('https://' + window.location.href.split('http://')[1]);
    }
    this.$store.dispatch('checkForWallet')
  },
  mounted() {
    // this.$store.commit('sounds/setupSounds');
    this.$store.commit('sounds/setupSounds');

    // Listen for action keys
    window.addEventListener('keydown', this.handleKeyDown);
    window.addEventListener('keyup', this.handleKeyUp);

    // Listen to remove cmd uses
    // TODO: Doesn't totally work yet
    document.addEventListener("visibilitychange", this.handleVisibilityChange);

    if (document.hasFocus() == true) {
    } else {
      window.focus();
    }

  },
  destroyed(){
    window.removeEventListener('keydown', this.handleKeyDown);
    window.removeEventListener('keyup', this.handleKeyUp);
    document.removeEventListener("visibilitychange", this.handleVisibilityChange);
  },
  computed: {
    canEdit() {
      if(this.$store.state.trust.canEdit === true) {
        return 'can-edit';
      } else {
        return '';
      }
    },
    shouldShowBg(){
      if(this.$store.state.trust.newBlock.isDragging) {
        return 'show';
      } else {
        return '';
      }
    },
  },
  setup () {

  },
  methods: {
     handleKeyDown(e) {
       if(e.key === 'Meta') {
         // this.$store.commit('setCanEdit', { newValue: true });
       } else if(e.key === 'Escape') {
         this.$store.commit('stopEditing', {reason: 'esc'});
         this.$store.commit('closeNewBlock', {reason: 'cancel'});
         this.$store.dispatch('closeLeft');
       }
     },
     handleKeyUp(e) {
       if(e.key === 'Meta') {
         // this.$store.commit('setCanEdit', { newValue: false });
       }
     },
     handleVisibilityChange(e){
       if (document.hidden) {
        this.windowFocused = 'hidden'
      } else  {
        this.windowFocused = 'visible'
      }
    },
    headHome(){
      this.$store.dispatch('routing/pushRoute', '/');
    }
  },
  watch: {
    '$route' (to) { // can also be (to, from)
      document.title = to.meta.title || 'Concept Trust'
    },
    'this.windowFocused' () {
      // this.$store.commit('setCanEdit', { newValue: false });
    },
  },
}
</script>

<style>
  @import './assets/styles/placeholder-base.css';
  @import './assets/styles/global.css';
  @import './assets/styles/mobile.css';


  .uploader__bg {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 10000;
    pointer-events: none;
  }

  .uploader__bg .bg {
    background: rgba(0,0,0,0.4);
    opacity: 0;
    height: 100%;
    width: 100%;
    transition: all 200ms ease-in-out;
  }

  .uploader__bg .text {
    font-size: 24px;
    color: white;
    left: 50%;
    top: 50%;
    opacity: 0;
    text-shadow: 3px 3px blue;
    position: absolute;
    transform: translate(-50%, -50%);
    transition: all 200ms ease-in-out;
  }

  .uploader__bg.show .bg,
  .uploader__bg.show .text {
    opacity: 1;
  }
</style>
